import Ajustes from '@/views/Ajustes/Ajustes.vue'
import CompaniasGPS from "../views/Ajustes/CompaniasGPS.vue";
import Usuarios from "../views/Ajustes/Usuarios/Usuarios.vue";
import Agentes from "../views/Ajustes/Agentes.vue";
import Plantillas from "../views/Ajustes/PlantillasUI/PlantillasUI.vue";
import Companias from "../views/Ajustes/Companias.vue";
import Reaseguradores from "../views/Ajustes/Reaseguradores.vue";
import Clientes from "../views/Ajustes/Clientes.vue";
import Paises from '../views/Ajustes/Paises.vue';
import Contenedores from '../views/Ajustes/Contenedores.vue';
import Assets from '../views/Ajustes/Assets.vue';
import SubAssets from '../views/Ajustes/SubAssets.vue';
import Productos from '../views/Ajustes/Productos.vue';
import MedidasDeSeguridad from '../views/Ajustes/MedidasDeSeguridad.vue';
import Taxes from '../views/Ajustes/Taxes.vue';
import storeAuth from "../store/auth";
import Roles from '../views/Ajustes/Roles.vue';
import Idiomas from '../views/Ajustes/Idiomas.vue';
import ExcepcionesOfac from '../views/Ajustes/ExcepcionesOfac.vue';
import ConfiguracionCertificados from '../views/Ajustes/ConfiguracionCertificados.vue';
import TypeAssets from '../views/Ajustes/TypeAssets.vue';
import TiposTransporte from '../views/Ajustes/TiposTransporte.vue';
import Corredores from '../views/Ajustes/Corredores.vue';

const AjustesRouter = [
  {
    path: 'ajustes',
    name: 'Ajustes',
    component: Ajustes,
    children: [
      {
        path: 'companias-gps',
        name: 'CompaniasGps',
        component: CompaniasGPS,
        beforeEnter: (to: any, from: any, next: any) => {
          const { user } = storeAuth()

          if (user?.permission.includes(to.name)) {
            next()
          } else {
            next('/panel/ajustes');
          }
        }
      },
      {
        path: 'usuarios',
        name: 'Usuarios',
        component: Usuarios,
      },
      {
        path: 'agentes',
        name: 'Agentes',
        component: Agentes,
      },
      {
        path: 'plantillas',
        name: 'Plantillas',
        component: Plantillas,
      },
      {
        path: 'companias',
        name: 'Companias',
        component: Companias,
        beforeEnter: (to: any, from: any, next: any) => {
          const { user } = storeAuth()

          if (user?.permission.includes('Companias ABM')) {
            next()
          } else {
            next({ name: 'Login' });
          }
        }
      },
      {
        path: 'reaseguradores',
        name: 'Reaseguradores',
        component: Reaseguradores,
        beforeEnter: (to: any, from: any, next: any) => {
          const { user } = storeAuth()

          if (user?.permission.includes('Reaseguradores')) {
            next()
          } else {
            next({ name: 'Login' });
          }
        }
      },
      {
        path: 'clientes',
        name: 'Clientes',
        component: Clientes,
        beforeEnter: (to: any, from: any, next: any) => {
          const { user } = storeAuth()

          if (user?.permission.includes('Clientes')) {
            next()
          } else {
            next({ name: 'Login' });
          }
        }
      },
      {
        path: 'paises',
        name: 'Paises',
        component: Paises,
      },
      {
        path: 'contenedores',
        name: 'Contenedores',
        component: Contenedores,
      },
      {
        path: 'roles',
        name: 'Roles',
        component: Roles,
      },
      {
        path: 'idiomas',
        name: 'Idiomas',
        component: Idiomas,
      },
      {
        path: 'assets',
        name: 'Assets',
        component: Assets,
      },
      {
        path: 'sub-assets',
        name: 'SubAssets',
        component: SubAssets,
      },
      {
        path: 'productos',
        name: 'Productos',
        component: Productos,
      },
      {
        path: 'medidas-de-seguridad',
        name: 'Medidas de seguridad',
        component: MedidasDeSeguridad,
      },
      {
        path: 'taxes',
        name: 'Taxes',
        component: Taxes,
      },
      {
        path: 'excepciones-ofac',
        name: 'Excepciones Ofac',
        component: ExcepcionesOfac,
      },
      {
        path: 'configuracion-certificados',
        name: 'Configuracion de Certificados',
        component: ConfiguracionCertificados,
      },
      {
        path: 'type-assets',
        name: 'TypeAssets',
        component: TypeAssets,
      },
      {
        path: 'tipos-transporte',
        name: 'Tipos de transporte',
        component: TiposTransporte,
        beforeEnter: (to: any, from: any, next: any) => {
          const { user } = storeAuth()

          if (user?.permission.includes('Tipos de transporte')) {
            next()
          } else {
            next({ name: 'Login' });
          }
        }
      },
      {
        path: 'corredores',
        name: 'Corredores',
        component: Corredores,
        beforeEnter: (to: any, from: any, next: any) => {
          const { user } = storeAuth()

          if (user?.permission.includes('Corredores')) {
            next()
          } else {
            next({ name: 'Login' });
          }
        }
      },
    ],
  },
];
export default AjustesRouter;
